/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tools_Planner_CtaInputs */

const en_control_tools_planner_cta = /** @type {(inputs: Control_Tools_Planner_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start planning`)
};

const zh_control_tools_planner_cta = /** @type {(inputs: Control_Tools_Planner_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始规划`)
};

/**
* | output |
* | --- |
* | "Start planning" |
*
* @param {Control_Tools_Planner_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tools_planner_cta = /** @type {((inputs?: Control_Tools_Planner_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tools_Planner_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tools_planner_cta(inputs)
	return zh_control_tools_planner_cta(inputs)
});
export { control_tools_planner_cta as "control.tools.planner.cta" }